import builder from '../builder';
import Archive from '../../streamline-icons/light/archive.svg';

export default builder('IconArchiveLight', Archive);
